// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import loadAllLocations from "@keller/App/Handlers/AllLocations/LoadAllLocations";
import loadDealersIndustries from "@keller/App/Handlers/Dealers/LoadDealersIndustries";
import { CustomAppState } from "@keller/App/Store/Reducers";
import { getGeoCurrentLocation } from "@keller/XDL/Utilities/location";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomAppState) => {
    return {
        shouldLoadIndustries:
            !state.xDealers.industriesDataView.industries && !state.xDealers.industriesDataView.isLoading,
    };
};

const mapDispatchToProps = {
    loadAllLocations,
    loadDealersIndustries,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AllLocationsPageStyles {
    page?: MobiusPageProps;
}

export const allLocationsPageStyles: AllLocationsPageStyles = {};
const styles = allLocationsPageStyles;

const AllLocationsPage = ({ id, loadAllLocations, shouldLoadIndustries, loadDealersIndustries }: Props) => {
    useEffect(() => {
        if (shouldLoadIndustries) {
            loadDealersIndustries({});
        }

        getGeoCurrentLocation({
            latitude: 0,
            longitude: 0,
        }).then(result => {
            loadAllLocations({
                name: "",
                latitude: result?.latitude,
                longitude: result?.longitude,
                getAllDealers: true,
            });
        });
    }, []);

    return (
        <Page data-test-selector="All-LocationsPage" {...styles.page}>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AllLocationsPage),
    definition: {
        displayName: "All Locations",
        hasEditableTitle: true,
        hasEditableUrlSegment: false,
        pageType: "System",
        fieldDefinitions: [],
    },
};

export default pageModule;
